export default function ImpactReporth4(props) {
    const getTextContent = (children) => {
        if (typeof children === 'string') return children;
        if (Array.isArray(children)) return children.map(getTextContent).join('');
        if (children?.props?.children) return getTextContent(children.props.children);
        return '';
    };

    const hyphenateAndLowercase = (str) => {
        // return str.replace(/\s+/g, '-').toLowerCase();
        return str
            .replace(/[^\w\s-]/g, '')   // Remove special characters except spaces and hyphens
            .replace(/\s+/g, '-')       // Replace spaces with hyphens
            .toLowerCase();
      }

    const id = hyphenateAndLowercase(getTextContent(props.children));

    return (
        <h4 
            id={id} 
            className={`impact-h4${props.className ? ' ' + props.className : ''}`}
            style={props.style}
        >
            {props.children}
        </h4>
    );

}